import { IEvents, } from "@json-rpc-tools/types";
export class ISequence extends IEvents {
    constructor(client, logger) {
        super();
        this.client = client;
        this.logger = logger;
    }
}
//# sourceMappingURL=sequence.js.map